import { useEffect, startTransition } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import AppRoutes from './routes/AppRoutes';
import { preloadCriticalImages } from './utils/imageLoader';
import { ToastProvider } from './contexts/ToastContext';
import store, { persistor } from './redux/store';
import LoadingSpinner from './components/LoadingSpinner';
import { useTheme } from './hooks/useTheme';

const App: React.FC = () => {
  // Initialize theme detection at app root level
  useTheme();

  useEffect(() => {
    // Preload critical images in the background using startTransition
    startTransition(() => {
      preloadCriticalImages();
    });
  }, []);

  return (
    <Provider store={store}>
      <PersistGate loading={<LoadingSpinner />} persistor={persistor}>
        <ToastProvider>
          <div className="App">
            <AppRoutes />
          </div>
        </ToastProvider>
      </PersistGate>
    </Provider>
  );
};

export default App;
